import { InfoWindow } from "@react-google-maps/api";

import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import { useRouter, usePathname } from "../../../hooks/useNavigation";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../../../contexts/ComponentContext";
import { useStores } from "../../../../contexts/StoreContext";
import getQueryString from "../../../helpers/getQueryString/getQueryString";

const StyledLogo = styled.img`
  max-height: 7.5rem;
`;

const StyledLink = styled.a`
  background: ${({ theme }) => theme.primaryColor};
`;

function MapInfoBox(props) {
  const { state, onClose } = props;
  const {
    companyId,
    formattedAddress,
    displayName,
    logoUrlFull,
    city,
    totalVacancies,
  } = state;

  const router = useRouter();
  const ogPathname = usePathname();

  const { filtersStore } = useStores();
  const { resetFilters } = filtersStore;
  const { resultsUrl } = useContext(ComponentContext);

  const pathname = isEmpty(resultsUrl) ? ogPathname : resultsUrl;
  const query = getQueryString({ companyId });
  const handleClick = () => {
    router
      .push({ pathname, query }, undefined, {
        shallow: true,
      })
      .then(() => resetFilters());
  };

  return (
    <InfoWindow onCloseClick={onClose} position={state.coords}>
      <div className="pt-2">
        <h5 className="fw-bold text-uppercase text-black">{displayName}</h5>
        <p>{formattedAddress || city}</p>
        {logoUrlFull && (
          <StyledLogo alt={displayName} className="mb-4" src={logoUrlFull} />
        )}
        <p className="text-black">
          <Link href={{ pathname, query }} passHref legacyBehavior>
            <StyledLink
              className="text-white fw-bold px-3 py-2 border-0 text-decoration-none"
              onClick={handleClick}
              type="button"
            >
              {`Vacancies: ${totalVacancies}`}
            </StyledLink>
          </Link>
        </p>
      </div>
    </InfoWindow>
  );
}

MapInfoBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  state: PropTypes.shape({
    city: PropTypes.string,
    companyId: PropTypes.string,
    coords: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
    displayName: PropTypes.string,
    formattedAddress: PropTypes.string,
    logoUrlFull: PropTypes.string,
    totalVacancies: PropTypes.number,
  }).isRequired,
};

export default observer(MapInfoBox);
